import { render, staticRenderFns } from "./ProcessedRequestEmail.vue?vue&type=template&id=67987a82&scoped=true&"
import script from "./ProcessedRequestEmail.vue?vue&type=script&lang=js&"
export * from "./ProcessedRequestEmail.vue?vue&type=script&lang=js&"
import style0 from "./ProcessedRequestEmail.vue?vue&type=style&index=0&id=67987a82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67987a82",
  null
  
)

export default component.exports